
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ArrowForward from '@mui/icons-material/ArrowForward';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import { useSnackbar } from 'notistack';
import { I18n, useTranslation } from 'components/hooks/use-translation';
import CardLayout from 'components/layouts/card-layout';
import Input from 'components/atomic/atoms/input';
import Text from 'components/atomic/atoms/text';
import devvSdk from 'utils/devv-sdk';
import Routes from 'utils/routes';
const initialFormValues = { email: '' };
const ForgotPassword = () => {
    const [loading, setLoading] = React.useState(false);
    // const [response, setResponse] = React.useState<{ status?: string; message?: string }>({})
    const { enqueueSnackbar } = useSnackbar();
    const { t }: I18n = useTranslation();
    const router = useRouter();
    const session = useSession();
    const ForgotPasswordSchema = React.useMemo(() => {
        return Yup.object().shape({
            email: Yup.string().email(t('common:errors.invalidEmail')).required(t('common:errors.requiredField')),
        });
    }, [t]);
    React.useEffect(() => {
        if (session.status === 'authenticated')
            router.push(Routes.Paths);
    }, [session, router]);
    const handleSubmit = async (values: {
        email: string;
    }) => {
        setLoading(true);
        await devvSdk
            .startPasswordReset(values.email)
            .then(() => {
            setLoading(false);
            enqueueSnackbar(t('forgotPassword:success.generic'), { variant: 'success' });
            // setResponse({ status: 'success', message: t('forgotPassword:success.generic') })
        })
            .catch((err) => {
            setLoading(false);
            console.error(err);
            enqueueSnackbar(t('forgotPassword:errors.generic'), { variant: 'error' });
            // setResponse({ status: 'error', message: t('forgotPassword:errors.generic') })
        });
    };
    const form = useFormik({
        initialValues: initialFormValues,
        onSubmit: handleSubmit,
        validationSchema: ForgotPasswordSchema,
    });
    return (<CardLayout title={t('forgotPassword:title')}>
            <Stack spacing="1rem">
                <Text variant="h4" color="primary">
                    {t('forgotPassword:title')}
                </Text>
                <Text variant="body2" style={{ marginBottom: '1rem' }}>
                    {t('forgotPassword:subtitle')}
                </Text>
                <Input label={t('forgotPassword:inputs.email')} onChange={form.handleChange('email')} value={form.values.email} error={form.touched.email ? !!form.errors.email : false} helperText={form.touched.email ? form.errors.email : undefined}/>
                <LoadingButton sx={{ marginTop: '1rem' }} onClick={() => form.handleSubmit()} loading={loading} size="large" color="primary" endIcon={<ArrowForward />} variant="contained">
                    {t('forgotPassword:buttons.continue')}
                </LoadingButton>
                {/* This is actually pretty nice, consider using it
        {response?.status && (
            <Alert variant="filled" severity={response.status as AlertColor}>
                {response.message}
            </Alert>
        )}
        */}
            </Stack>
        </CardLayout>);
};
export default ForgotPassword;

    async function __Next_Translate__getStaticProps__18916ceb193__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/forgot-password',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb193__ as getStaticProps }
  